import { at } from 'lodash';
import { useField } from 'formik';
import { FormHelperText, FormControl, TextareaAutosize } from '@mui/material';

export default function InputField(props: any) {
  const { errorText, ...rest } = props;
  const [field, meta] = useField(props);
  const [touched, error] = at(meta, 'touched', 'error');
  const isError = touched && error && true;
  function _renderHelperText() {
    if (isError) {
      return <FormHelperText>{error}</FormHelperText>;
    }
  }

  return (
    <FormControl {...rest} error={isError}>
      <TextareaAutosize
        {...field}
        {...rest}
      />
      {_renderHelperText()}
    </FormControl>
  );
}
